import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Spin, Select, Modal } from 'antd';
import './assets/css/package.css';
import dummyImage from './assets/Rectangle 187.png';
import calendarIcon from './assets/calendar 1.png';
import { useHistory, useParams } from 'react-router';
import {
  useGetAllPackagesQuery,
  useGetConvertedCurrencyMutation,
  useGetPackagesDetailsByIdQuery,
} from './packageSlice';
import {
  CatchReportSlider,
  PackagesSlider,
} from '../../common/components/sliders';

import breakfastIcon from './assets/croissant.svg';
import wifiIcon from './assets/wi-fi.svg';
import taxiIcon from './assets/location.svg';
import mealIcon from './assets/lunch.svg';
import otherBenefitIcon from './assets/star.svg';
import globeIcon from './ManagePackage.js/images/globe 1.svg';
import ukFlag from './assets/flags/united-kingdom 1.svg';
import { useGetFisheryQuery } from '../../fishery_profile/fisherySlice';
import { languages } from './QuoteBooking';
import { languageTranslation } from '../../../lang';

function PackageDetails() {
  const fisheryId = useParams()['fishery_id'];
  const packageId = useParams()['package_id'];
  const [convertCurrency] = useGetConvertedCurrencyMutation();
  const { data: fisheryData } = useGetFisheryQuery(fisheryId);
  const [currency, setCurrency] = useState(fisheryData?.currency);
  const [language, setLanguage] = useState('en-GB');
  const [showlanguageChange, setShowLanguageChange] = useState(false);
  const [convertedPackages, setConvertedPackages] = useState();
  const [convertedPackageDetails, setConvertedPackageDetails] = useState();
  let CurrencyList = [
    { code: 'GBP', name: 'British Pound Sterling', symbol: '£' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
    { code: 'USD', name: 'United States Dollar', symbol: '$' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
    { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
    { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
    { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
    { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
    { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
    { code: 'THB', name: 'Thai Baht', symbol: '฿' },
  ];
  const languageOptions = languages?.map(({ code, name, flag }) => ({
    label: (
      <span>
        <span>
          <img src={flag} width={14} alt='' className='mg-right-5' />
        </span>
        <span className='txt-underline sb-blue-500'>{name}</span>
      </span>
    ),
    value: code,
  }));
  const [currencySymbol, setCurrencySymbol] = useState('');
  // useEffect(() => {
  //   setCurrency(fisheryData?.currency);
  //   setCurrencySymbol(
  //     CurrencyList.find((i) => i.code === fisheryData?.currency)?.symbol
  //   );
  // }, [fisheryData]);

  const countryOptions = CurrencyList?.sort(({ code: x }, { code: y }) =>
    x === 'GBP' ? -1 : y === 'GBP' ? 1 : 0
  )?.map(({ code, name }) => ({
    label: (
      <span>
        {name} ({code})
      </span>
    ),
    value: code,
  }));
  const history = useHistory();
  const { data: packages, isLoading: packageDetailLoading } =
    useGetPackagesDetailsByIdQuery(
      { fishery_id: fisheryId, package_id: packageId },
      {
        skip: !fisheryId && !packageId,
      }
    );
  const { data: AllPackages, isLoading: packagesLoading } =
    useGetAllPackagesQuery(fisheryId, {
      skip: !fisheryId,
    });
  useEffect(() => {
    setConvertedPackageDetails(packages?.[0]);
  }, [packages]);
  useEffect(() => {
    setTimeout(() => {
      setCurrency('GBP');
      setCurrencySymbol(CurrencyList.find((i) => i.code === 'GBP')?.symbol);
    }, 1000);
  }, []);
  useEffect(() => {
    const convertPackageItem = async () => {
      if (!currency || !fisheryData?.currency) return;

      const updatedArray = await Promise.all(
        packages?.map(async (item) => {
          try {
            const converted = await convertCurrency({
              amount: item?.final_price_in_pence / 100,
              currency_from: fisheryData.currency,
              currency_to: currency,
            }).unwrap();

            return {
              ...item,
              currency: currency,
              convertedAmount: converted,
            };
          } catch (error) {
            console.error('Currency conversion failed:', error);
            return {
              ...item,
              currency: currency,
              convertedAmount: null,
            };
          }
        })
      );

      setConvertedPackageDetails(updatedArray?.[0]);
    };
    convertPackageItem();
  }, [currency, packages, fisheryData]);

  useEffect(() => {
    const convertCartItems = async () => {
      if (!currency || !fisheryData?.currency) return;

      const updatedArray = await Promise.all(
        AllPackages.map(async (item) => {
          try {
            const converted = await convertCurrency({
              amount: item?.final_price_in_pence / 100,
              currency_from: fisheryData.currency,
              currency_to: currency,
            }).unwrap();

            return {
              ...item,
              currency: currency,
              convertedAmount: converted,
            };
          } catch (error) {
            console.error('Currency conversion failed:', error);
            return {
              ...item,
              currency: currency,
              convertedAmount: null,
            };
          }
        })
      );

      setConvertedPackages(updatedArray);
    };

    convertCartItems();
  }, [currency, AllPackages]);

  useEffect(() => {
    setConvertedPackages(AllPackages);
  }, [AllPackages]);
  const activeLanguage = languageTranslation[language];
  let Package = packages?.[0];
  return (
    <div className='booking-container'>
      <div style={{ maxWidth: 1400 }} className='mg-auto'>
        <div style={{ marginTop: 160 }}>
          <Modal
            className='language_modal'
            open={showlanguageChange}
            width='min(40rem, 95%)'
            closable={false}
            maskClosable={false}
            centered
            destroyOnClose
            onOk={() => {}}
            onCancel={() => {
              setShowLanguageChange(false);
            }}
            footer=''
          >
            <>
              <div
                className='language_modal_title gSemiBold fs-18'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  paddingLeft: '24px',
                }}
              >
                <img
                  src={globeIcon}
                  alt='certificate'
                  style={{ width: '22px', height: '22px' }}
                />
                <span>Change Currency / Language</span>
              </div>
              <div style={{ padding: '16px 16px 0 16px', marginTop: '60px' }}>
                <div className='row-center gap-1r flex-wrap'>
                  <div className='row-center mg-right-0 w-full'>
                    <div
                      className='fs-13 gSemiBold grey-700 mg-right-10'
                      style={{ width: 65 }}
                    >
                      Language:
                    </div>
                    <Select
                      className='br5 mg-left-10 gBold currency-select w-full'
                      style={{ textAlign: 'left', flex: 1 }}
                      value={language}
                      onChange={(v) => {
                        setLanguage(v);
                      }}
                      popupClassName='gBold'
                      optionFilterProp='label'
                      options={languageOptions}
                    />
                  </div>
                  <div className='row-center  mg-right-0 w-full flex-wrap'>
                    <div
                      className='fs-13 gSemiBold grey-700 mg-right-10'
                      style={{ width: 60 }}
                    >
                      Currency:
                    </div>
                    <Select
                      className='br5 mg-left-10 gBold w-full  currency-select'
                      style={{ flex: 1 }}
                      value={currency}
                      onChange={(v) => {
                        setCurrency(v);
                        const selected = CurrencyList.find((c) => c.code === v);
                        if (selected) {
                          setCurrencySymbol(selected.symbol);
                        }
                      }}
                      optionFilterProp='label'
                      popupClassName='payment_form__selector'
                      options={countryOptions}
                    />
                  </div>
                </div>

                <Col span={24} className='mg-top-30'>
                  <div className=' w-full row-center gap-2r justify-end'>
                    <Button
                      className='gBold br8 fs-14 white txt-center sb-blue-bg-600 hover:sb-blue-bg-700 pd-10 '
                      style={{
                        width: 162,
                        maxWidth: '100%',
                        height: 'auto',
                      }}
                      onClick={() => {
                        setShowLanguageChange(false);
                      }}
                    >
                      Save Changes
                    </Button>
                  </div>
                </Col>
              </div>
            </>
          </Modal>
          <div className='row-center mg-right-0 mg-bottom-20 flex-wrap gap-1r language-select-desktop'>
            <div className='row-center justify-between mg-right-20'>
              <div className='fs-13 gSemiBold grey-700 mg-right-20'>
                Language:
              </div>
              <Select
                className='br5  gBold language-select'
                style={{ width: 150, textAlign: 'left' }}
                value={language}
                onChange={(v) => {
                  setLanguage(v);
                }}
                popupClassName='gBold'
                optionFilterProp='label'
                options={languageOptions}
              />
            </div>
            <div className='row-center  mg-right-20 flex-wrap'>
              <div className='fs-13 gSemiBold grey-700 mg-right-20'>
                Select Currency:
              </div>
              <Select
                className='br5  gBold currency-select'
                style={{ width: 220 }}
                value={currency}
                onChange={(v) => {
                  setCurrency(v);
                  const selected = CurrencyList.find((c) => c.code === v);
                  if (selected) {
                    setCurrencySymbol(selected.symbol);
                  }
                }}
                optionFilterProp='label'
                popupClassName='payment_form__selector'
                options={countryOptions}
              />
            </div>
          </div>
          <div
            className='language-select-mobile'
            onClick={() => {
              setShowLanguageChange(true);
            }}
          >
            <img src={ukFlag} alt='uk' className='mg-right-10' width={17} />
            Change Currency / Language
          </div>

          <div className='package-details-container details'>
            {packageDetailLoading ? (
              <div className='row-center'>
                <Spin />
              </div>
            ) : (
              <Row gutter={[40, 20]} className='package-row '>
                <Col
                  xs={{ order: 2, span: 24 }}
                  md={{ span: 14, order: 1 }}
                  className='package-content'
                >
                  <div className='row-center mg-bottom-10'>
                    <h3 className='package-title mg-bottom-0'>
                      {convertedPackageDetails?.name}
                    </h3>
                    <div className='gBold  fs-10 row-center fs-10 mg-left-10'>
                      {convertedPackageDetails?.package_type ===
                        'last_minute' ||
                      convertedPackageDetails?.package_type === 'early_bird' ? (
                        <span
                          className=' fs-14 txt-center '
                          style={{
                            borderRadius: '100px',
                            background: '#FFD98F',
                            color: '#5C3D00',
                            width: 120,
                            padding: '2px 12px',
                          }}
                        >
                          {
                            activeLanguage?.reservation?.[
                              convertedPackageDetails?.package_type
                            ]
                          }
                        </span>
                      ) : convertedPackageDetails?.package_type ===
                        'specific_date_range' ? (
                        <span
                          className=' fs-14 txt-center '
                          style={{
                            borderRadius: '100px',
                            background: '#D9EEFF',
                            color: '#0D3759',
                            width: 120,
                            padding: '2px 12px',
                          }}
                        >
                          {activeLanguage?.reservation?.date_range}
                        </span>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <p className='package-description'>
                    {convertedPackageDetails?.description}
                  </p>

                  {/* Features */}
                  <Row gutter={[10, 10]} className='details-package-features'>
                    {convertedPackageDetails?.included_benefits
                      .filter((b) => b.selected)
                      .map((benefit) => (
                        <Col xs={12} sm={8}>
                          <div className='feature-item'>
                            <img
                              src={
                                benefit?.label === 'Daily Breakfast'
                                  ? breakfastIcon
                                  : benefit?.label === 'Internet'
                                    ? wifiIcon
                                    : benefit?.label === 'Pickup Included' ||
                                        benefit?.label === 'Dropoff Included'
                                      ? taxiIcon
                                      : benefit?.label === 'Meals Included'
                                        ? mealIcon
                                        : ''
                              }
                              width={18}
                              height={18}
                              alt='benefit'
                              className='mg-right-5'
                            />{' '}
                            {benefit?.customText
                              ? benefit?.customText
                              : benefit?.label}
                          </div>
                        </Col>
                      ))}
                    {convertedPackageDetails?.other_benefits?.data
                      .filter((b) => b.selected)
                      .map((benefit) => (
                        <Col xs={12} sm={8}>
                          <span className='feature-item'>
                            <img
                              src={otherBenefitIcon}
                              width={16}
                              height={16}
                              alt='benefit'
                              className='mg-right-5'
                            />{' '}
                            {benefit?.name}
                          </span>
                        </Col>
                      ))}
                  </Row>

                  {/* Pricing */}
                  <div className='package-pricing'>
                    <div className='package-details-price-container mg-bottom-10 flex-wrap row-center justify-between'>
                      <span className='package-price-label  uppercase font-montserrat sb-blue-700'>
                        {activeLanguage?.reservation?.packagePrice}
                      </span>
                      <div
                        className='package-price  sb-blue-bg-100 txt-center font-montserrat sb-blue-700'
                        style={{ minWidth: 205 }}
                      >
                        {convertedPackageDetails?.currency}
                        {convertedPackageDetails?.convertedAmount
                          ? convertedPackageDetails?.convertedAmount.toFixed(2)
                          : (
                              convertedPackageDetails?.final_price_in_pence /
                              100
                            ).toFixed(2)}
                      </div>
                    </div>
                    <div className='package-details-price-container flex-wrap row-center justify-between'>
                      <span className='package-price-label uppercase  font-montserrat sb-blue-700'>
                        {activeLanguage?.quote_summary?.pay_today}
                      </span>
                      <div
                        className='package-price  sb-blue-bg-100 txt-center font-montserrat sb-blue-700'
                        style={{ minWidth: 205 }}
                      >
                        {convertedPackageDetails?.currency}
                        {convertedPackageDetails?.convertedAmount
                          ? (
                              convertedPackageDetails?.convertedAmount * 0.3
                            ).toFixed(2)
                          : (
                              (convertedPackageDetails?.final_price_in_pence /
                                100) *
                              0.3
                            ).toFixed(2)}
                      </div>
                    </div>
                  </div>

                  {/* Booking Button */}
                  <Button
                    className='details-book-button uppercase'
                    onClick={() => {
                      history.push(
                        `/booking/package/reservation/${fisheryId}/${Package?.id}`
                      );
                    }}
                  >
                    {activeLanguage?.reservation?.check_availabilty_book}
                  </Button>
                </Col>
                <Col
                  xs={{ order: 1, span: 24 }}
                  md={{ span: 10, order: 2 }}
                  className='package-image-container'
                >
                  <div className='package-image-wrapper'>
                    {convertedPackageDetails?.package_image && (
                      <img
                        src={convertedPackageDetails?.package_image}
                        alt='Fishing Package'
                        className='package-details-image'
                      />
                    )}
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </div>

        {AllPackages && (
          <PackagesSlider
            lakesData={convertedPackages}
            activeLanguage={activeLanguage}
            fisheryPublicId={fisheryId}
            loading={packagesLoading}
          />
        )}
      </div>
    </div>
  );
}

export default PackageDetails;
